import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    refreshFlag: false
  },
  getters: {},
  mutations: {
    triggerRefresh(state) {
      state.refreshFlag = !state.refreshFlag
    }
  },
  actions: {},
  modules: {},
});
